import http from '../utils/http'
//
/**
 * //https://yjz.hsnms.com/app/mutual/assistance/3?appid=202108&type_id=3001
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

let resquest = "https://yjz.hsnms.com/app";
let appid = 202204;
let token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6MCwiQVBQSUQiOjIwMjIwNCwiVXNlcklkIjoiIiwiVXNlck5hbWUiOiIiLCJPcGVuaWQiOiIwMDAwIiwiSGVhZGltZ3VybCI6IiIsIkF1dGhvcml0eUtleSI6MCwiQXV0aG9yaXR5VmFsdWUiOiJHVUVTVCIsImV4cCI6MTY4MTQ3MTU5OCwiaXNzIjoiaHNubXMiLCJuYmYiOjE2NDk5MzQ1OTh9.WVJQdusWYM_kF8xscNc4WR7-k8LJXFW7tZg31qrvd2Y"


export function getAPI(url, params) {
	console.log(`${resquest}/${url}&callback=json&appid=${appid}&token=${token}`);
	return http.get(`${resquest}/${url}&state=1&callback=json&appid=${appid}&token=${token}`, params)
}
export function postAPI(url, params) {
	console.log(`${resquest}/${url}&callback=json&appid=${appid}&token=${token}`);
	return http.post(`${resquest}/${url}&state=1&callback=json&appid=${appid}&token=${token}`, params)
}

export function setOpenid() {
	const info = JSON.parse(window.sessionStorage.getItem('openid'))
	console.log(info);
	//info="8afac2ed6026a8ae01604d88a3f06b14";
	return "8afac2ed6026a8ae01604d88a3f06b14"
}

//设置Token
export function setToken(Token) {
	window.sessionStorage.setItem('token', JSON.stringify(Token));
}
export function setTokenVisitor() {
	var Token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6MCwiQVBQSUQiOjIwMjIwNCwiVXNlcklkIjoiIiwiVXNlck5hbWUiOiIiLCJPcGVuaWQiOiIwMDAwIiwiSGVhZGltZ3VybCI6IiIsIkF1dGhvcml0eUtleSI6MCwiQXV0aG9yaXR5VmFsdWUiOiJHVUVTVCIsImV4cCI6MTY4MTQ3MTU5OCwiaXNzIjoiaHNubXMiLCJuYmYiOjE2NDk5MzQ1OTh9.WVJQdusWYM_kF8xscNc4WR7-k8LJXFW7tZg31qrvd2Y"
	window.sessionStorage.setItem('token', JSON.stringify(Token));
}

//获取用户model
export function getUserInfo () {
  const info = JSON.parse(window.sessionStorage.getItem('user_model_gh'))
  console.log(info);
  return info
}
//更新用户model
export function getUserInfo_updata (openid) {
  http.get(`${resquest}/mutual/attribute/?appid=202108&type_id=4001`, {
    openid: openid,
	token:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6MCwiQVBQSUQiOjIwMjEwOCwiVXNlcklkIjoiIiwiVXNlck5hbWUiOiLmnajntKvnkLQiLCJPcGVuaWQiOiI4YWZhYzgxOTZjYmM0NTRiMDE2Y2JjOTEwOGY5NGIwNyIsIkhlYWRpbWd1cmwiOiIiLCJBdXRob3JpdHlLZXkiOjAsIkF1dGhvcml0eVZhbHVlIjoiR1VFU1QiLCJleHAiOjE2NzQ1NDA4NTEsImlzcyI6Imhzbm1zIiwibmJmIjoxNjQzMDAzODUxfQ.v0qUOPkmv_6HlTjh4GBCiQjWt-iqmA6UW7IoFtouCp0",
  }).then(res => {
    const user_model = res.data.data.data[0].models[0];
    console.log(user_model);
    console.log("user_model");
    const rowObj = JSON.stringify(user_model)
    window.sessionStorage.setItem('user_model_gh', rowObj);
  });
}
export function getUserInfo_jurisdiction (openid) {
	const user_info=getUserInfo()
	if(user_info!=null){
		console.log("user_info");
		return user_info
	}
	//alert(openid)
	if(openid==undefined){
		console.log("nullnullnullnullnullnull");
		return null
	}
	console.log("us2222222222er_model");
	return getUserInfo_updata(openid)
}







// get请求
export function getListAPI (params) {
  console.log(params);
  return http.get(`${resquest}/mutual/assistance/3?appid=202108&type_id=3001`, params)
}
// post请求
export function postFormAPI (params) {
  return http.post(`${resquest}/postForm.json`, params)
}
// put 请求
export function putSomeAPI (params) {
  return http.put(`${resquest}/putSome.json`, params)
}
// delete 请求
export function deleteListAPI (params) {
  return http.delete(`${resquest}/deleteList.json`, params)
}



// WEBPACK FOOTER //
// ./src/api/api.js